// extracted by mini-css-extract-plugin
module.exports = {"tag-color":"d1VFD","tagColor":"d1VFD"};